import { Check } from '@mui/icons-material';
import { Stack, Chip } from '@mui/material';
import { withChildrenSlideAnimation } from '@/components/shared/animation';
import {
  BaseQuestion,
  type BaseQuestionProps,
} from '@/packages/profile-quiz/components/questions/base-question';

interface RadioQuestionProps extends Omit<BaseQuestionProps, 'children'> {
  handleSelectAnswer: (answer: string) => void;
  currentValue?: string | null;
  options: {
    label: string;
    value: string;
  }[];
}

const AnimatedStack = withChildrenSlideAnimation(Stack);
export const RadioQuestion = ({
  questionTitle,
  processedResponseText,
  questionId,
  handleSelectAnswer,
  currentValue,
  options,
}: RadioQuestionProps) => {
  return (
    <BaseQuestion
      questionTitle={questionTitle}
      processedResponseText={processedResponseText}
      questionId={questionId}
    >
      <AnimatedStack
        sx={{ gap: 1, alignItems: 'flex-start' }}
        animationStepDelay={100}
      >
        {options.map(({ label, value: optionValue }) => {
          const isChecked = currentValue === optionValue;
          return (
            <Chip
              key={optionValue}
              label={label}
              variant="outlined"
              color={isChecked ? 'secondary' : 'default'}
              icon={isChecked ? <Check /> : undefined}
              onClick={() => handleSelectAnswer(optionValue)}
            />
          );
        })}
      </AnimatedStack>
    </BaseQuestion>
  );
};
